import { atom } from 'jotai';
import type { ReportType } from 'pages/bugs-features/types';

/**
 * The report form is reachable from the app header on every page, so its open
 * state cannot live inside the reports page. Both the header button and the
 * page's own "Report an issue" button set this, and one modal instance is
 * rendered at the app shell.
 */
export const isReportFormOpenAtom = atom(false);

/**
 * Which radio the form opens on. Set by the two header icons — the bug glyph
 * opens on Bug, the lightbulb on Feature Request — so the choice is made by which
 * thing you clicked rather than by a dropdown after the fact.
 */
export const reportFormInitialTypeAtom = atom<ReportType>('bug');

/**
 * Bumped after each successful submit. The listing watches it to refetch, which
 * keeps the page decoupled from the modal now that the two no longer share a
 * component tree.
 */
export const reportSubmittedAtom = atom(0);

/**
 * What a crash knows about itself, handed to the form when the error page opens it.
 *
 * Deliberately not folded into the description. The description is the reporter's — what
 * they were trying to do — and prefilling it with a stack trace both buries that question
 * and invites them to delete the only part an engineer can act on. This travels alongside,
 * verbatim and not editable, and is captured the same way page_url already is.
 *
 * Null whenever the form is opened any other way, which is most of the time.
 */
export const reportFormErrorAtom = atom<ReportFormError | null>(null);

export interface ReportFormError {
  /** The thrown message, e.g. "Cannot read properties of undefined". */
  message: string;
  /** Truncated: a stack is unbounded and this ends up in a jsonb column and a Jira ticket. */
  stack?: string;
}
